export const htmlAttributes = {
  '*': [
    'about',
    'acceptCharset',
    'accessKey',
    'allowFullScreen',
    'allowTransparency',
    'autoComplete',
    'autoFocus',
    'autoPlay',
    'capture',
    'cellPadding',
    'cellSpacing',
    'charSet',
    'classID',
    'className',
    'colSpan',
    'contentEditable',
    'contextMenu',
    'crossOrigin',
    'dangerouslySetInnerHTML',
    'datatype',
    'dateTime',
    'dir',
    'draggable',
    'encType',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'frameBorder',
    'hidden',
    'hrefLang',
    'htmlFor',
    'httpEquiv',
    'icon',
    'id',
    'inlist',
    'inputMode',
    'is',
    'itemID',
    'itemProp',
    'itemRef',
    'itemScope',
    'itemType',
    'keyParams',
    'keyType',
    'lang',
    'marginHeight',
    'marginWidth',
    'maxLength',
    'mediaGroup',
    'minLength',
    'noValidate',
    'prefix',
    'property',
    'radioGroup',
    'readOnly',
    'resource',
    'role',
    'rowSpan',
    'scoped',
    'seamless',
    'security',
    'spellCheck',
    'srcDoc',
    'srcLang',
    'srcSet',
    'style',
    'suppressContentEditableWarning',
    'tabIndex',
    'title',
    'typeof',
    'unselectable',
    'useMap',
    'vocab',
    'wmode'
  ],
  'a': [
    'coords',
    'download',
    'href',
    'name',
    'rel',
    'shape',
    'target',
    'type'
  ],
  'abbr': [
    'title'
  ],
  'audio': [
    'controls',
    'loop',
    'muted',
    'preload',
    'src'
  ],
  'base': [
    'href',
    'target'
  ],
  'bdo': [
    'dir'
  ],
  'blockquote': [
    'cite'
  ],
  'button': [
    'disabled',
    'form',
    'name',
    'type',
    'value'
  ],
  'canvas': [
    'height',
    'width'
  ],
  'col': [
    'span',
    'width'
  ],
  'colgroup': [
    'span',
    'width'
  ],
  'data': [
    'value'
  ],
  'del': [
    'cite'
  ],
  'fieldset': [
    'disabled',
    'form',
    'name'
  ],
  'form': [
    'accept',
    'action',
    'method',
    'name',
    'target'
  ],
  'hr': [
    'size',
    'width'
  ],
  'iframe': [
    'height',
    'name',
    'sandbox',
    'scrolling',
    'src',
    'width'
  ],
  'img': [
    'alt',
    'height',
    'name',
    'sizes',
    'src',
    'width'
  ],
  'input': [
    'accept',
    'alt',
    'autoCapitalize',
    'autoCorrect',
    'autoSave',
    'checked',
    'defaultChecked',
    'defaultValue',
    'disabled',
    'form',
    'height',
    'list',
    'max',
    'min',
    'multiple',
    'name',
    'onChange',
    'pattern',
    'placeholder',
    'required',
    'results',
    'size',
    'src',
    'step',
    'title',
    'type',
    'value',
    'width'
  ],
  'label': [
    'form'
  ],
  'li': [
    'type',
    'value'
  ],
  'meta': [
    'content',
    'name'
  ],
  'ol': [
    'reversed',
    'start',
    'type'
  ],
  'optgroup': [
    'disabled',
    'label'
  ],
  'option': [
    'disabled',
    'label',
    'selected',
    'value'
  ],
  'pre': [
    'width'
  ],
  'progress': [
    'max',
    'value'
  ],
  'q': [
    'cite'
  ],
  'select': [
    'defaultValue',
    'disabled',
    'form',
    'multiple',
    'name',
    'onChange',
    'required',
    'size',
    'value'
  ],
  'source': [
    'media',
    'sizes',
    'src',
    'type'
  ],
  'table': [
    'summary',
    'width'
  ],
  'td': [
    'headers',
    'height',
    'scope',
    'width'
  ],
  'textarea': [
    'autoCapitalize',
    'autoCorrect',
    'cols',
    'defaultValue',
    'disabled',
    'form',
    'name',
    'onChange',
    'placeholder',
    'required',
    'rows',
    'value',
    'wrap'
  ],
  'th': [
    'headers',
    'height',
    'scope',
    'width'
  ],
  'ul': [
    'type'
  ],
  'video': [
    'controls',
    'height',
    'loop',
    'muted',
    'poster',
    'preload',
    'src',
    'width'
  ],
  'address': [],
  'article': [],
  'aside': [],
  'b': [],
  'bdi': [],
  'br': [],
  'caption': [],
  'cite': [],
  'code': [],
  'datalist': [],
  'dd': [],
  'div': [],
  'dl': [],
  'dt': [],
  'em': [],
  'figcaption': [],
  'figure': [],
  'footer': [],
  'h1': [],
  'h2': [],
  'h3': [],
  'h4': [],
  'h5': [],
  'h6': [],
  'header': [],
  'hgroup': [],
  'i': [],
  'legend': [],
  'main': [],
  'nav': [],
  'p': [],
  'picture': [],
  's': [],
  'section': [],
  'small': [],
  'span': [],
  'strong': [],
  'sub': [],
  'summary': [],
  'sup': [],
  'svg': [
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baseProfile",
    "baselineShift",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "color",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "height",
    "horizAdvX",
    "horizOriginX",
    "ideographic",
    "imageRendering",
    "in",
    "in2",
    "intercept",
    "k",
    "k1",
    "k2",
    "k3",
    "k4",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "points",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "scale",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "vHanging",
    "vIdeographic",
    "vMathematical",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "viewBox",
    "viewTarget",
    "visibility",
    "width",
    "widths",
    "wordSpacing",
    "writingMode",
    "x",
    "x1",
    "x2",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlSpace",
    "xmlns",
    "xmlnsXlink",
    "y",
    "y1",
    "y2",
    "yChannelSelector",
    "z",
    "zoomAndPan"
  ],
  'tbody': [],
  'tfoot': [],
  'thead': [],
  'tr': [],
  'u': [],
  'wbr': []
}

export const svgElements = [
  "a",
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "script",
  "set",
  "stop",
  "style",
  "switch",
  "symbol",
  "text",
  "textPath",
  "title",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]

export default Object.keys(htmlAttributes).filter(x => x !== '*')
